import React, { useContext } from 'react';
import { Paper, PaperProps } from '@mui/material';
import { ActiveTabContext } from './ActiveTabContext';

export interface TabPanelProps<T extends string> extends PaperProps {
  tabsId: string;
  value: T;
}

export function TabPanel<T extends string = string>(props: TabPanelProps<T>) {
  const { children, tabsId, value, ...other } = props;
  const activeTab = useContext(ActiveTabContext);

  if (value !== activeTab) {
    return null;
  }

  return (
    <Paper
      role="tabpanel"
      id={`${tabsId}-tabpanel-${value}`}
      aria-labelledby={`${tabsId}-tab-${value}`}
      elevation={0}
      variant="outlined"
      square
      sx={{
        padding: 4,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        ...other.sx,
      }}
      {...other}
    >
      {(value === activeTab) && children}
    </Paper>
  );
}
